import { createFileRoute } from "@tanstack/react-router";
import ComplianceWordbook from "./-complianceWordbook";

export const Route = createFileRoute("/_layout/system/complianceWordbook")({
  staticData: {
    menuLabel: "合规词表配置",
    showInMenu: false,
    menuGroup: "/system",
    menuOrder: 4,
  },
  component: ComplianceWordbook,
});
